
export const navigationPathsMap = new Map([
  ['/', {
    title: 'navbar.dipEmergenza',
    text: '',
    route: '/',
  }],
  ['/status', {
    title: 'homePageTotem.statusProntoSoccorso',
    text: '',
    route: '/status',
  }],
  ['/chisiamo', {
    title: 'navbar.dipEmergenza',
    text: '',
    route: '/chisiamo',
  }],
  ['/monitoraggio', {
    title: 'navbar.statusPaziente',
    text: '',
    route: '/monitoraggio',
  }],
  ['/faq', {
    title: 'navbar.faqHeader',
    text: '',
    route: '/faq',
  }],
]);